export default "/fonts/vendor/katex/dist/KaTeX_Caligraphic-Bold.ttf?7489a2fbfb9bfe70442031a27fb57a21";